import { FiBarChart2, FiCpu, FiGlobe, FiPenTool, FiShield, FiSmartphone } from "react-icons/fi";

const icons = {
  Cybersecurity: FiShield,
  "Mobile development": FiSmartphone,
  "Web development": FiGlobe,
  "Data analytics": FiBarChart2,
  "UX/UI design": FiPenTool,
  "AI / ML": FiCpu,
};

export default function AreaIcon({ title, size = 18 }) {
  const Icon = icons[title];
  if (!Icon) return null;
  return <Icon aria-hidden="true" size={size} className="text-[var(--kicker)]" />;
}
